import { Progress, type ProgressProps } from 'antd';
import type { Ref } from 'react';

export interface BaseProgressProps extends ProgressProps {
  ref?: Ref<HTMLDivElement>;
}

/** 进度保留零值、状态和原生线形/环形能力，不生成或修改业务进度。 */
export default function BaseProgress({
  className,
  ...props
}: BaseProgressProps) {
  return (
    <Progress
      {...props}
      className={['base-progress', className].filter(Boolean).join(' ')}
    />
  );
}
